<template>
  <NuxtLayout>
    <NuxtPage />
    <!-- Teleported to body; client-only because the tracking_id lives in localStorage. -->
    <ClientOnly>
      <StaffModeNotice />
    </ClientOnly>
  </NuxtLayout>
</template>

<script setup lang="ts">
const config = useRuntimeConfig();
const siteOrigin = config.public.mainUrl as string;

// lang is set once in nuxt.config (en-GB) — do not redeclare here.
// Stable @id so CollectionPage / other nodes can reference this WebSite via
// isPartOf without every page carrying a disconnected copy.
useSchemaGraph("ld-website", [
  {
    "@type": "WebSite",
    "@id": `${siteOrigin}/#website`,
    name: "&Dine",
    url: siteOrigin,
    publisher: { "@id": `${siteOrigin}/#organization` },
    potentialAction: {
      "@type": "SearchAction",
      target: `${siteOrigin}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
]);
</script>
